<template>
  <b-modal
    :id="modalRef"
    :ref="modalRef"
    :ok-disabled="true"
  >
    <div slot="modal-header">
      <h4>{{ projectToDelete.projectName }}</h4>
    </div>
    Are you sure you want to delete this project?
    <div slot="modal-footer">
      <b-button
        class="mr-3"
        variant="danger"
        @click="confirmDelete"
      >
        Delete
      </b-button>
      <b-button
        variant="primary"
        @click="cancel"
      >
        Cancel
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import store from './../../store/store.js'
  import {mapActions} from 'vuex';

  export default {
    name: "DeleteProjectModal",
    props: {
      projectToDelete: Object,
      parentKey: Number
    },
    computed: {
      modalRef() {
        return 'deleteProjectModal-' + this.projectToDelete.id
      }
    },
    methods: {
      ...mapActions('rx',[
        'deleteProject',
        'getAvailableProjects'
      ]),
      confirmDelete(){
        this.deleteProject(this.projectToDelete.id).then(() => {
          this.getAvailableProjects();
          this.$refs[this.modalRef].hide();
          this.$emit('confirm-delete')
        });
      },
      cancel(){
        this.$refs[this.modalRef].hide()
      }
    }


  }
</script>

<style scoped>

</style>